










































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import BaseVue from "@/core/BaseVue";
import TipoTramiteComponentProp from "@/helpers/tipoTramiteComponentProp.helper";
import { PropOptions } from "vue";
import Miembro from "../../models/miembro/miembro.model";
import BTableConfig from "@/core/BTableConfig/BTableConfig";
import Persona from "@/models/persona/persona.model";
import { Utils } from "@/core/Utils";
import TramiteBeneficiario from "@/models/tramite/tramiteBeneficiario.model";
import SolicitudCambioComposicionFamiliar, {
  SolicitudCambioComposicionFamiliarExclusion,
  SolicitudCambioComposicionFamiliarDocumento
} from "@/models/tramite/solicitud-cambio-composicion-familiar/";
import Beneficiario from "@/models/beneficiario/beneficiario.model";
import TipoTramite from "@/models/tipoTramite";
import BaseRepository from "@/core/HttpResources/BaseRepository";

import GenericBTable from "@/core/Generics/GenericBTable";
import BTableColumn from "@/models/base/BTableColumn.model";
import { BTableColumnType } from "@/enums/BTableColumnType";
import Helpers from "@/helpers/helper";

@Component
export default class CambioComposicionFamiliarExclusionResumen extends GenericBTable<
  SolicitudCambioComposicionFamiliarExclusion
> {
  @Prop() readonly tipoTramite!: TipoTramite;
  @Prop() readonly solicitante!: Persona;
  @Prop() readonly beneficiario!: Beneficiario;
  @Prop() readonly content!: TramiteBeneficiario;

  get hogarId() {
    if (this.beneficiario && this.beneficiario.hogarId)
      return this.beneficiario.hogarId;
    return 0;
  }
  get hogarCode() {
    if (this.beneficiario && this.beneficiario.codigoHogar)
      return this.beneficiario.codigoHogar;
    return "";
  }
  get tramiteBeneficiarioId() {
    if (this.content && this.content.id) return this.content.id;
    if (this.$route.params.id) return this.$route.params.id;
    return 0;
  }
  created() {
    this.tableConfig.controller = "SolicitudCambioComposicionFamiliarExclusion";
    this.tableConfig.include = "Miembro.Parentesco|Persona|RazonExclusion";
    this.tableConfig.activeActions = false;
    this.tableConfig.detailed = true;
    this.tableConfig.whereParams = this.getWhereParams();
    this.formatColumns();
  }
  getWhereParams() {
    let result = [];
    result.push(
      `SolicitudCambioComposicionFamiliar.TramiteBeneficiarioId="${this.tramiteBeneficiarioId}"`
    );

    return result.join("&");
  }
  getPersona(
    id: number,
    nombre: string,
    cedula: string,
    foto: string,
    model: Persona
  ) {
    let persona = model || new Persona();
    persona.id = id;
    persona.nombreCompleto = nombre;
    persona.cedula = cedula;
    persona.foto = foto;
    return persona;
  }
  formatColumns() {
    let persona = new BTableColumn(
      "personaId",
      this.isMobile ? "Nombre" : "Nombre completo"
    );
    persona.customTemplate = true;
    persona.templateSlot = "persona";
    let edad = new BTableColumn("persona.fechaNacimiento", "Edad");
    edad.customTemplate = true;
    edad.templateSlot = "column-edad";
    let parentesco = new BTableColumn(
      "miembro.parentescoNombre",
      "Parentesco",
      false
    );
    let sexo = new BTableColumn("persona.sexo", "Genero");
    sexo.type = BTableColumnType.Custom;
    sexo.customFilter = Helpers.Filters.Sexo;
    let razon = new BTableColumn(
      "razonExclusionNombre",
      "Razón de exclusión",
      false
    );
    this.tableConfig.insertColumns(persona, edad, parentesco, sexo, razon);
  }
}
